import React from 'react';
import styled from 'styled-components';
import { string, object, number, element } from 'prop-types';
import { CaptionText } from '../Text/Heading';
import Wrapper from '../Wrapper';
import Icon from '../Icon';

const LocationIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.greyDark};
  vertical-align: text-bottom;
  margin-right: 4px;
  min-width: 14px;
`;

const Location = ({
  location,
  theme,
  numberOfLines,
  iconSize,
  textProps,
  children,
}) => (
  <Wrapper display="flex">
    <LocationIcon icon="LocationOnIcon" fontsize={iconSize} />
    <CaptionText
      {...textProps}
      className="location"
      numberOfLines={numberOfLines}
      paddingBottom={children ? '4px' : '0px'}
    >
      {`${location}`}
      {children}
    </CaptionText>
  </Wrapper>
);

Location.defaultProps = {
  numberOfLines: 1,
  iconSize: 'small',
  textProps: {},
  children: null,
};

Location.propTypes = {
  location: string,
  theme: object,
  numberOfLines: number,
  iconSize: string,
  textProps: object,
  children: element,
};

export default Location;
